/**
 * 判断路径是否为外部链接
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:|http:)/.test(path)
}

// 其他可能用到的验证函数...